import React from 'react';
import Spinner from 'view/components/Spinner';

const SmsResponseStatistics = ({
	statistics,
	isLoading,
	statsDays,
	onDaysChange,
	onRefresh,
}) => {
	if (isLoading) {
		return (
			<div className="card mb-4">
				<div className="card-body text-center py-5">
					<Spinner />
					<p className="text-muted mt-3">Loading statistics...</p>
				</div>
			</div>
		);
	}

	if (!statistics?.stats) {
		return null;
	}

	const { stats } = statistics;

	return (
		<div className="sms-response-statistics mb-4">
			<div className="d-flex justify-content-end mb-2">
				<select
					className="form-select form-select-sm"
					style={{ width: 'auto' }}
					value={statsDays}
					onChange={(e) => onDaysChange(parseInt(e.target.value, 10))}
				>
					<option value={1}>Last 24 hours</option>
					<option value={7}>Last 7 days</option>
					<option value={30}>Last 30 days</option>
					<option value={90}>Last 90 days</option>
				</select>
				<button
					className="btn btn-sm btn-outline-secondary ms-2"
					onClick={onRefresh}
				>
					<i className="bi bi-arrow-clockwise" />
				</button>
			</div>
			<div className="row g-3">
				<div className="col-md-3">
					<div className="card stat-card">
						<div className="card-body">
							<p className="text-muted mb-1">Total inbound</p>
							<h3 className="mb-0">{(stats.total || 0).toLocaleString()}</h3>
						</div>
					</div>
				</div>
				<div className="col-md-3">
					<div className="card stat-card">
						<div className="card-body">
							<p className="text-muted mb-1">With app reply</p>
							<h3 className="mb-0 text-success">
								{(stats.with_reply || 0).toLocaleString()}
							</h3>
						</div>
					</div>
				</div>
				<div className="col-md-3">
					<div className="card stat-card">
						<div className="card-body">
							<p className="text-muted mb-1">Ignored</p>
							<h3 className="mb-0 text-muted">
								{(stats.ignored || 0).toLocaleString()}
							</h3>
						</div>
					</div>
				</div>
				<div className="col-md-3">
					<div className="card stat-card">
						<div className="card-body">
							<p className="text-muted mb-1">Unmatched users</p>
							<h3 className="mb-0 text-warning">
								{(stats.unmatched_users || 0).toLocaleString()}
							</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SmsResponseStatistics;
